module.exports = __webpack_public_path__ + "img/company-highlight-03.99c851ca.jpg";